<template>
  <ValidationProvider ref="nationalIdProvider" :name="name" :rules="rules" v-slot="{ errors }">
    <label v-if="isShowLable" class="pb-2" :class="{ 'Required': isRequired }">{{ label }}</label>
    <v-text-field ref="inputRef" solo type="text" minlength="10" maxlength="10" inputmode="number"
      :placeholder="placeholder" v-bind="$attrs" @input="onInput($event)" @change="onChange($event)"
      :error-messages="errors"></v-text-field>
  </ValidationProvider>
</template>
<script lang="ts">
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';

import { Regex } from '@/utils/regex';
import { Utils } from '@/utils/utils';

@Component
export default class NationalIdComponent extends Vue {
  @Prop({ default: '' }) inputValue!: string;
  @Prop({ default: false }) isIqama!: boolean;
  @Prop({ default: true }) isShowLable!: boolean;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: false }) isRequired!: boolean;
  rules = 'required|max:10|min:10|nationalId';
  placeholder = this.$t('nationalIdPlaceholder').toString();
  label = this.$t('nationalIdLabel').toString();

  /** The component name. */
  name = 'nationalId';

  mounted() {
    this.isIqamaChanged();
  }

  onKeydown(event: KeyboardEvent) {
    Utils.AllowDigitsKeys(event);
  }

  onChange(value: string) {
    if (!Regex.Numbers.test(value)) {
      (this.$refs.inputRef as any).reset();
      return;
    }

    this.$emit('update:inputValue', value);
  }

  async onInput(value: string): Promise<void> {
    const result = await (this.$refs.nationalIdProvider as any).validate(value);
    this.$emit('input', value);

    if (this.index !== -1) {
      this.$emit('controlDataChanged', { value, index: this.index, isValid: result.valid });
    }
  }

  @Watch('isIqama')
  isIqamaChanged() {
    if (this.isIqama) {
      this.placeholder = this.$t('iqamaPlaceholder').toString();
      this.rules = 'required|max:10|min:10|iqama';
      this.label = this.$t('iqamaLabel').toString();
      this.name = 'iqama';
    } else {
      this.placeholder = this.$t('nationalIdPlaceholder').toString();
      this.rules = 'required|max:10|min:10|nationalId';
      this.label = this.$t('nationalIdLabel').toString();
      this.name = 'nationalId';
    }
  }
}
</script>
